import React, { useEffect } from "react";
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Grid } from '@material-ui/core';
import styles from "../setting.module.css";
import { ReactComponent as VectorSuccess } from '../../../utils/assets/Vector_success.svg';
import ModalCloseButton from '../../../components/UI/ModalCloseButton';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    height: 270,
    bgcolor: 'background.paper',
    borderRadius: '5px',
    p: 4
};

export default function SuccessModal(props) {
    const { setOpen, open, setOpenedEmail } = props
    useEffect(() => {
        setOpenedEmail(false)
        // eslint-disable-next-line
    }, [open]);
    return (
        <div>
            <Modal
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Grid container>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "flex-end", marginTop: "-1rem" }}>
                            <ModalCloseButton style={{ position: "static" }} onClick={() => setOpen(false)} />
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem" }}>
                            <VectorSuccess/>
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center"}}>
                            <p className={styles.SuccesstModelText1}>Your request has been sent to the Admin for approval. You</p>
                        </Grid>
                        <Grid item md={12} style={{ display: "flex", justifyContent: "center"}}>
                            <p className={styles.SuccesstModelText2}>will receive a notification once Admin approves.</p>
                        </Grid>
                    </Grid>
                </Box>
            </Modal>
        </div>
    );
}